import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { selectFeatureFlagEnabledByKey } from '@shared/store';

@Injectable({
  providedIn: 'root',
})
export class FeatureToggleGuard {
  constructor(private store: Store) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.store.select(selectFeatureFlagEnabledByKey(route.data?.featureKey));
  }
}
